import { render, staticRenderFns } from "./ls-pagination.vue?vue&type=template&id=c0da2c16&scoped=true&"
import script from "./ls-pagination.vue?vue&type=script&lang=ts&"
export * from "./ls-pagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0da2c16",
  null
  
)

export default component.exports